import { EventsByDate } from '../types/Event'

export class EventPaginatedService {
  constructor(eventByDates: EventsByDate | null, currentPage: number, eventsDayPerPage: number) {
    this.eventByDates = eventByDates
    this.eventDates = Object.keys(eventByDates ?? {})
    this.numberOfDays = this.eventDates.length ?? 0

    const indexOfLastRecord = currentPage * eventsDayPerPage
    const paginatedEventDates = this.eventDates.slice(0, indexOfLastRecord)

    this.paginatedEvents = paginatedEventDates
    this.currentPage = currentPage
    this.totalPageCount =
      this.eventDates.length < eventsDayPerPage ? 1 : Math.ceil(this.eventDates.length / eventsDayPerPage)
  }

  public eventByDates: EventsByDate | null
  public numberOfDays: number
  public eventDates: string[]

  public paginatedEvents: string[]
  public totalPageCount: number
  public currentPage: number
}
